import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { ListStartupModal } from './ListStartupModal';

export const Navigation = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [listStartupModalOpen, setListStartupModalOpen] = useState(false);

  const menuItems = [
    { label: 'Home', path: '/' },
    { label: 'Stories', path: '/stories' },
    { label: 'Articles', path: '/articles', comingSoon: true },
    { label: 'About', path: '/about' },
  ];

  return (
    <nav className="sticky top-0 z-50 bg-card/95 backdrop-blur-sm border-b border-border shadow-sm">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <div className="text-2xl font-bold font-heading">
              <span className="text-gradient-primary">Starticals</span>
            </div>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-6">
            {menuItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className="relative text-foreground/80 hover:text-foreground transition-colors text-sm font-medium"
              >
                {item.label}
                {item.comingSoon && (
                  <Badge variant="secondary" className="ml-2 text-xs">Soon</Badge>
                )}
              </Link>
            ))}
            <Button variant="editorial" size="sm" onClick={() => setListStartupModalOpen(true)}>
              List Your Startup
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 hover:bg-accent rounded-lg transition-colors"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-border pt-4 space-y-3">
            {menuItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className="block text-foreground/80 hover:text-foreground transition-colors py-2 text-sm font-medium"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                <div className="flex items-center justify-between">
                  {item.label}
                  {item.comingSoon && (
                    <Badge variant="secondary" className="text-xs">Soon</Badge>
                  )}
                </div>
              </Link>
            ))}
            <Button 
              variant="editorial" 
              size="sm" 
              className="w-full mt-4" 
              onClick={() => {
                setListStartupModalOpen(true);
                setIsMobileMenuOpen(false);
              }}
            >
              List Your Startup
            </Button>
          </div>
        )}
      </div>
      
      {/* List Startup Modal */}
      <ListStartupModal 
        open={listStartupModalOpen} 
        onOpenChange={setListStartupModalOpen} 
      />
    </nav>
  );
};
